import ActiveController from "rapid/controller";

export class liveViewPreviewController extends ActiveController {
    constructor($injector, $rootScope, $element, $scope, $timeout) {
        "ngInject";
        super($injector);

        this.$rootScope = $rootScope;
        this.$element = angular.element($element);
        this.$scope = $scope;
        this.orientation = "";
        this.width = 0;
        this.height = 0;
        this.captureSize = 0;
        this.outputHeight = 0;
        this.renderedArray = [];
        this.$timeout = $timeout;
        this.boomerangCount = null;

        $scope.$watch(() => this.prWidth, () => {
            this.changeSize();
        });

        $scope.$watch(() => this.prHeight, () => {
            this.changeSize();
        });

        $scope.$watch(() => this.mode, () => {
            this.changeSize();
        });

    }

    $onInit() {
        this.changeSize();
    }

    changeSize() {
        this.width  = Math.round(Number(this.prWidth)/Number(this.index));
        this.height = Math.round(Number(this.prHeight)/Number(this.index));

        this.orientation = this.width > this.height ? "landscape" : "portrait";

        this.captureSize = Math.round(Number(this.width > this.height ? this.prHeight : this.prWidth)/Number(this.index)) - 60;
        this.captureheight = Math.round(Number(this.width < this.height ? this.prHeight : this.prWidth)/Number(this.index)) - 60;

        this.outputHeight = this.orientation !== "portrait"
            ? (this.captureSize - this.captureheight / 6)
            : (this.captureheight - this.captureheight / 4);

    }

    isVideo(name) {
        if (name === undefined || name === null || name === "") {
            return false;
        }
        return (
            name.indexOf(".mp4") !== -1 ||
            name.indexOf(".webm") !== -1 ||
            name.indexOf(".mov") !== -1
        );
    }

    shouldShowBackgroundMedia() {
        return this.enabled && (this.mode !== "fullscreen" || this.screen === "output");
    }

    shouldShowImageBackground() {
        return this.shouldShowBackgroundMedia()
            && this.bgMode === "image"
            && this.background
            && !(this.videoBackground && this.isVideo(this.videoBackground));
    }

    shouldShowVideoBackground() {
        return this.shouldShowBackgroundMedia()
            && this.bgMode === "image"
            && this.videoBackground
            && this.isVideo(this.videoBackground);
    }
}



// WEBPACK FOOTER //
// ./sources/components/common/live-view-preview/live-view-preview.controller.js